import Layout1 from '@/layout/Layout1'

export default [{
  path: '/accountspayable',
  component: Layout1,
  children: [{
    path: 'vendor/:id',
    component: () => import('@/components/accountspayable/maintenance/vendors/vendorEdit')
  }, {
    path: 'vendor',
    component: () => import('@/components/accountspayable/maintenance/vendors/vendorList')
  }, {
    path: 'shippingmethod/:id',
    component: () => import('@/components/accountspayable/maintenance/shippingmethodmasters/shippingmethodmasterEdit')
  }, {
    path: 'shippingmethod',
    component: () => import('@/components/accountspayable/maintenance/shippingmethodmasters/shippingmethodmasterList')
  }, {
    path: 'taxdetail/:id',
    component: () => import('@/components/accountspayable/maintenance/taxdetails/taxdetailEdit')
  }, {
    path: 'taxdetail',
    component: () => import('@/components/accountspayable/maintenance/taxdetails/taxdetailList')
  }]
}]
